import React, { Component, createRef } from 'react';
import ReactDOM from 'react-dom';
import styles from '../styles/components/AlertBox.scss';
import classNames from 'classnames';
import WarningIcon from '../assets/images/warning-30x30.svg';
import { mapStateToProps } from '../core/utils';
import Button from './Button';
import * as _ from 'lodash';
import { hideAlertbox } from '../redux/actions/general/alertbox';

@mapStateToProps((state) => ({
  ...state.general.alertbox,
  osd_viewer: state.fabric_overlay?.viewer,
}))
class AlertBox extends Component {
  alertBoxRef = createRef();

  toggleBlur = (add = true) => {
    const { osd_viewer } = this.props;

    if (osd_viewer?.container && osd_viewer?.isFullPage()) {
      const canvasDiv = document.querySelector('.openseadragon-canvas');
      if (canvasDiv) {
        canvasDiv.classList.toggle('blur', add);
      }
    } else {
      const root = document.getElementById('root');
      if (root) {
        root.classList.toggle('blur', add);
      }
    }
  };

  componentDidMount() {
    if (this.props.title) {
      this.toggleBlur(true);
    }
  }

  componentWillUnmount() {
    if (this.props.title) {
      this.toggleBlur(false);
    }
  }

  renderContent() {
    const { color, title, description, buttons } = this.props;

    return !title ? (
      ''
    ) : (
      <div
        className={classNames(
          styles.wrapper,
          color == 'red' && styles.red,
          color == 'blue' && styles.blue
        )}
      >
        <div className={styles.box}>
          <div className={styles.header}>
            <span>{title}</span>
            <WarningIcon />
          </div>
          <div className={styles.content}>{description}</div>
          {!_.isEmpty(buttons) && (
            <div className={styles.footer}>
              {_.map(buttons, (button, i) => {
                const styles = [];
                styles[button.color] = true;

                return (
                  <Button
                    medium
                    key={i}
                    onClick={
                      button.onClick == 'close' ? hideAlertbox : button.onClick
                    }
                    middleText={button.text}
                    {...styles}
                  />
                );
              })}
            </div>
          )}
        </div>
      </div>
    );
  }

  render() {
    const { osd_viewer } = this.props;
    const content = this.renderContent();

    return osd_viewer?.container && osd_viewer.isFullPage()
      ? ReactDOM.createPortal(content, osd_viewer.container)
      : content;
  }
}

export default AlertBox;
